export const isValidDateString = (value: string): boolean => {
  if (!value) return false;
  const date = new Date(value);
  return !isNaN(date.getTime());
};

export const parseDateOrNull = (value: string): Date | null => {
  if (!isValidDateString(value)) return null;
  return new Date(value);
};

export interface ValidateDateRangeOptions {
  allowEqual?: boolean;
}

export interface ValidateResult {
  ok: boolean;
  error?: string;
}

export const validateDateRange = (
  startDateTime: string,
  endDateTime: string,
  options: ValidateDateRangeOptions = {}
): ValidateResult => {
  const { allowEqual = false } = options;

  if (!startDateTime || !endDateTime) {
    return { ok: false, error: '시작시간과 종료시간을 모두 입력하세요.' };
  }

  const start = parseDateOrNull(startDateTime);
  const end = parseDateOrNull(endDateTime);

  if (!start || !end) {
    return { ok: false, error: '유효한 날짜/시간 형식이 아닙니다.' };
  }

  if (allowEqual) {
    if (start.getTime() > end.getTime()) {
      return { ok: false, error: '시작시간이 종료시간보다 늦을 수 없습니다.' };
    }
  } else {
    if (start.getTime() >= end.getTime()) {
      return { ok: false, error: '시작시간은 종료시간보다 빨라야 합니다.' };
    }
  }

  return { ok: true };
};
